import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../Navbar';
import api from '../../utils/api';
import RequisitionsMonitor from './RequisitionsMonitor';
import JDBuilder from './JDBuilder';
import CandidateScreening from './CandidateScreening';
import EvaluationSetup from './EvaluationSetup';
import DataImport from './DataImport';
import TeamManagementView from '../TeamManagementView';
import HRExitManagement from './HRExitManagement';
import HiringPipeline from './HiringPipeline';
import HROverview from './HROverview';
import InterviewsManager from './InterviewsManager';
import BookedCandidatesList from './BookedCandidatesList';
import DesktopAgentSetup from './DesktopAgentSetup';

const HRDashboard = () => {
  const { activeTab: urlTab } = useParams();
  const navigate = useNavigate();
  const activeTab = urlTab || 'overview';
  const [hrUser, setHrUser] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState({
    dashboard: true,
    sourcing: true,
    interviewsGroup: true,
    operations: true
  });

  useEffect(() => {
    // Fetch logged-in user details
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      if (parsed.user_type === 'HR' || parsed.role === 'HR') {
        setHrUser(parsed);
      } else {
        setHrUser(parsed); // Allow flexibility for debugging
      }
    } else {
      setHrUser({
        full_name: 'Shravani Sinha',
        email: 'shravani@arkalaksh.com',
        org_name: 'Arkalaksh Technologies',
        user_type: 'HR'
      });
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const menuGroups = [
    {
      id: 'dashboard',
      label: 'Main Dashboard',
      submenus: [
        {
          id: 'overview',
          label: 'Overview Dashboard',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          )
        }
      ]
    },
    {
      id: 'sourcing',
      label: 'Talent Sourcing',
      submenus: [
        {
          id: 'requisitions',
          label: 'Requisitions Monitor',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 002 2h2a2 2 0 002-2z" />
            </svg>
          )
        },
        {
          id: 'jd-builder',
          label: 'JD Builder & Openings',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          )
        },
        {
          id: 'screening',
          label: 'Candidate AI Screening',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-13.332 9-18.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          )
        },
        {
          id: 'pipeline',
          label: 'Candidate Pipeline',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          )
        },
        {
          id: 'evaluations',
          label: 'Evaluation Setup',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
          )
        }
      ]
    },
    {
      id: 'interviewsGroup',
      label: 'Coordination Hub',
      submenus: [
        {
          id: 'interviews',
          label: 'Interview Scheduling',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          )
        },
        {
          id: 'booked-candidates',
          label: 'Booked Candidates',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
            </svg>
          )
        }
      ]
    },
    {
      id: 'operations',
      label: 'Operations & Offboarding',
      submenus: [
        {
          id: 'team',
          label: 'Team Management',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          )
        },
        {
          id: 'exits',
          label: 'Offboarding',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          )
        },
        {
          id: 'data-import',
          label: 'Import Employees & Projects',
          icon: (
            <svg style={styles.tabIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          )
        }
      ]
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <HROverview />;
      case 'requisitions':
        return <RequisitionsMonitor />;
      case 'jd-builder':
        return <JDBuilder />;
      case 'screening':
        return <CandidateScreening />;
      case 'pipeline':
        return <HiringPipeline />;
      case 'evaluations':
        return <EvaluationSetup />;
      case 'data-import':
        return <DataImport />;
      case 'interviews':
        return <InterviewsManager />;
      case 'booked-candidates':
        return <BookedCandidatesList />;
      case 'team':
        return <TeamManagementView hideNavbar={true} onBack={() => navigate('/hr-dashboard')} />;
      case 'exits':
        return <HRExitManagement />;
      default:
        return <HROverview />;
    }
  };

  return (
    <div style={styles.wrapper}>
      <Navbar 
        isLoggedIn={true} 
        userName={hrUser?.full_name} 
        activeTab="hiring-pipeline" 
      />
      <div style={styles.dashboardContainer}>
        {/* SIDEBAR */}
        <aside style={styles.sidebar}>
          <div style={styles.userCard}>
            <div style={styles.avatar}>
              {hrUser?.full_name ? hrUser.full_name.charAt(0).toUpperCase() : 'H'}
            </div>
            <div style={styles.userInfo}>
              <h4 style={styles.userName}>{hrUser?.full_name || 'HR Portal'}</h4>
              <p style={styles.userOrg}>{hrUser?.org_name || 'Organization'}</p>
              <span style={styles.roleBadge}>HR ADMIN</span>
            </div>
          </div>

          <nav style={styles.navMenu}>
            {menuGroups.map((group) => {
              const isGroupExpanded = expandedGroups[group.id];
              return (
                <div key={group.id} style={styles.menuGroupWrapper}>
                  {/* Parent Group Header */}
                  <button
                    onClick={() => toggleGroup(group.id)}
                    style={styles.groupHeader}
                  >
                    <div style={styles.groupHeaderLeft}>
                      <span style={styles.groupLabel}>{group.label}</span>
                    </div>
                    <svg
                      style={{
                        ...styles.chevronIcon,
                        transform: isGroupExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                      }}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {/* Collapsible Submenus List */}
                  <div
                    style={{
                      ...styles.submenuContainer,
                      maxHeight: isGroupExpanded ? '500px' : '0px',
                      opacity: isGroupExpanded ? 1 : 0,
                      pointerEvents: isGroupExpanded ? 'auto' : 'none',
                    }}
                  >
                    {group.submenus.map((sub) => {
                      const isActive = activeTab === sub.id;
                      return (
                        <button
                          key={sub.id}
                          onClick={sub.onClick ? sub.onClick : (sub.id === 'overview' ? () => navigate('/hr-dashboard') : () => navigate(`/hr-dashboard/${sub.id}`))}
                          style={{
                            ...styles.submenuItem,
                            ...(isActive ? styles.submenuItemActive : {})
                          }}
                        >
                          <span style={{
                            ...styles.submenuIconWrapper,
                            ...(isActive ? styles.submenuIconWrapperActive : {})
                          }}>
                            {sub.icon}
                          </span>
                          <span style={styles.submenuLabel}>{sub.label}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </nav>

          <div style={styles.sidebarFooter}>
            <button onClick={handleLogout} style={styles.logoutBtn}>
              <svg style={styles.logoutIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Sign Out
            </button>
          </div>
        </aside>

        {/* MAIN PANEL */}
        <main style={styles.mainPanel}>
          <div style={styles.contentScrollWrapper}>
            {renderContent()}
          </div>
        </main>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--bg-page)',
    color: 'var(--text-primary)',
    fontFamily: "'Inter', sans-serif"
  },
  dashboardContainer: {
    flex: 1,
    display: 'flex',
    maxWidth: '1600px',
    width: '100%',
    margin: '0 auto',
    padding: 'clamp(16px, 1.8vw, 24px) clamp(14px, 1.5vw, 20px)',
    boxSizing: 'border-box',
    gap: 'clamp(16px, 1.8vw, 24px)',
    overflow: 'hidden'
  },
  sidebar: {
    width: 'clamp(210px, 16vw, 245px)',
    flexShrink: 0,
    background: 'var(--bg-card-glass)',
    backdropFilter: 'blur(16px)',
    border: '1px solid var(--border-light)',
    borderRadius: '16px',
    padding: '12px 14px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'var(--shadow-md)',
    boxSizing: 'border-box',
    height: 'calc(100vh - 84px)',
    position: 'sticky',
    top: '70px'
  },
  userCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    paddingBottom: '12px',
    borderBottom: '1px solid var(--border-color)',
    marginBottom: '12px'
  },
  avatar: {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, var(--primary-color) 0%, #3b82f6 100%)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '15px',
    fontWeight: '800',
    boxShadow: '0 3px 8px rgba(79, 70, 229, 0.25)'
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
    overflow: 'hidden'
  },
  userName: {
    margin: 0,
    fontSize: '13.5px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  userOrg: {
    margin: 0,
    fontSize: '11px',
    color: 'var(--text-muted)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  roleBadge: {
    alignSelf: 'flex-start',
    marginTop: '2px',
    fontSize: '9px',
    fontWeight: '700',
    letterSpacing: '0.8px',
    padding: '1px 6px',
    borderRadius: '4px',
    background: 'var(--accent-color-transparent)',
    color: 'var(--primary-color)',
    border: '1px solid rgba(79, 70, 229, 0.2)'
  },
  navMenu: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
    overflowY: 'auto',
    paddingRight: '2px',
    marginRight: '-2px'
  },
  menuGroupWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '4px'
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 4px 4px 4px',
    border: 'none',
    background: 'transparent',
    color: 'var(--text-muted)',
    fontSize: '10.5px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    width: '100%',
    boxSizing: 'border-box',
  },
  groupHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  groupLabel: {
    flex: 1,
  },
  chevronIcon: {
    width: '12px',
    height: '12px',
    color: 'var(--text-muted)',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  submenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    overflow: 'hidden',
    transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    paddingLeft: '2px',
    marginTop: '2px',
  },
  submenuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '5px 8px 5px 10px',
    borderRadius: '8px',
    border: 'none',
    background: 'transparent',
    color: 'var(--text-secondary)',
    fontSize: '12.5px',
    fontWeight: '500',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    width: '100%',
    boxSizing: 'border-box'
  },
  submenuItemActive: {
    background: 'var(--bg-hover)',
    color: 'var(--text-primary)',
    fontWeight: '600'
  },
  submenuIconWrapper: {
    width: '26px',
    height: '26px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    color: 'var(--text-muted)',
    transition: 'all 0.2s'
  },
  submenuIconWrapperActive: {
    background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
    color: 'var(--primary-color)'
  },
  tabIcon: {
    width: '15px',
    height: '15px'
  },
  submenuLabel: {
    flex: 1
  },
  sidebarFooter: {
    paddingTop: '10px',
    borderTop: '1px solid var(--border-color)',
    marginTop: '10px'
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    width: '100%',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid var(--border-color)',
    background: 'transparent',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.2s'
  },
  logoutIcon: {
    width: '16px',
    height: '16px'
  },
  mainPanel: {
    flex: 1,
    height: 'calc(100vh - 120px)',
    overflowY: 'auto',
    boxSizing: 'border-box'
  },
  contentScrollWrapper: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  welcomeBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(15, 23, 42, 0.4)',
    backdropFilter: 'blur(8px)',
    zIndex: 99999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  welcomeCard: {
    background: 'var(--bg-card, #ffffff)',
    border: '1px solid var(--border-light, rgba(0, 0, 0, 0.05))',
    borderRadius: '24px',
    padding: '36px',
    maxWidth: '480px',
    width: '90%',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    fontFamily: "'Inter', sans-serif"
  },
  welcomeEmoji: {
    fontSize: '48px',
    lineHeight: '1'
  },
  welcomeTitle: {
    margin: 0,
    fontSize: '20px',
    fontWeight: '800',
    color: 'var(--text-primary)'
  },
  welcomeText: {
    margin: 0,
    fontSize: '14px',
    color: 'var(--text-secondary)',
    lineHeight: '1.5'
  },
  welcomeSubtext: {
    margin: 0,
    fontSize: '13px',
    color: 'var(--text-muted, #64748b)',
    lineHeight: '1.5'
  },
  welcomeActions: {
    display: 'flex',
    gap: '12px',
    width: '100%',
    marginTop: '8px'
  },
  welcomePrimaryBtn: {
    flex: 1,
    padding: '12px 20px',
    background: 'linear-gradient(135deg, var(--primary-color) 0%, #3b82f6 100%)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '700',
    fontSize: '13.5px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.25)',
    transition: 'all 0.2s ease'
  },
  welcomeSecondaryBtn: {
    padding: '12px 20px',
    background: 'transparent',
    color: 'var(--text-secondary)',
    border: '1px solid var(--border-light, #e2e8f0)',
    borderRadius: '12px',
    fontWeight: '600',
    fontSize: '13.5px',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  }
};

export default HRDashboard;
